import dynamic from 'next/dynamic';

import { breakUpLongTask } from '@utils/breakUpLongTasks';
export default dynamic(breakUpLongTask(() => import(/* webpackChunkName:"SubscriptionForm" */ './SubscriptionForm')));

export type { ISubscriptionForm } from './SubscriptionForm';
